import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-input" }
const _hoisted_2 = { class: "chat-relative" }
const _hoisted_3 = {
  ref: "absolute",
  class: "chat-absolute"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InputFiles = _resolveComponent("InputFiles")
  const _component_Question = _resolveComponent("Question")
  const _component_InputControls = _resolveComponent("InputControls")
  const _component_Footnote = _resolveComponent("Footnote")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["container-block", {focused: $data.focused, generating: $props.generating, recording: $data.recording}]),
          onClick: _cache[6] || (_cache[6] = (...args) => ($options.focus && $options.focus(...args)))
        }, [
          ($props.controls && $options.uploads_enabled)
            ? (_openBlock(), _createBlock(_component_InputFiles, {
                key: 0,
                ref: "uploads",
                "files-store": $data.f_store
              }, null, 8 /* PROPS */, ["files-store"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_Question, {
            ref: "question",
            question: $props.question,
            onAnswerAi: $options.onAnswerAI,
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, null, 8 /* PROPS */, ["question", "onAnswerAi"]),
          _createVNode(_component_InputControls, {
            ref: "controls",
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.value) = $event)),
            "can-upload": $options.can_upload,
            recording: $data.recording,
            placeholder: $options.c_placeholder,
            generating: $props.generating,
            "can-push": $options.can_push,
            "uploads-enabled": $options.uploads_enabled,
            loading: $data.caps_loading,
            expanded: $props.expanded,
            onPush: $options.onPush,
            onFocusin: _cache[2] || (_cache[2] = $event => ($data.focused = true)),
            onFocusout: _cache[3] || (_cache[3] = $event => ($data.focused = false)),
            onStop: $options.onStop,
            onUpload: $options.uploadFile,
            onPrompt: _cache[4] || (_cache[4] = $event => (_ctx.value = $event)),
            onTranscribed: _cache[5] || (_cache[5] = $event => (_ctx.value = $event))
          }, null, 8 /* PROPS */, ["modelValue", "can-upload", "recording", "placeholder", "generating", "can-push", "uploads-enabled", "loading", "expanded", "onPush", "onStop", "onUpload"])
        ], 2 /* CLASS */),
        ($props.footnote)
          ? (_openBlock(), _createBlock(_component_Footnote, {
              key: 0,
              class: "footer",
              type: "default"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.description), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])), [
        [_directive_resize, $options.setHeight]
      ])
    ])
  ]))
}